/**
 * @generated SignedSource<<a9d49697fdb5e6fa1214ad9922c36878>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableGroupByDropdown_GroupByDropdown_project">;
  readonly " $fragmentType": "topBar_issueNavigator_project";
};
export type topBar_issueNavigator_project$key = {
  readonly " $data"?: topBar_issueNavigator_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueTableGroupByDropdown_GroupByDropdown_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "d575af71dac5fde22ea8516feb77a91e";

export default node;
